import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [];

@NgModule({
  imports: [RouterModule.forChild([
    { path: '', data: { breadcrumb : '' }, loadChildren: () => import('./caixa-gerenciar-listar/caixa-gerenciar-listar.module').then(m => m.CaixaGerenciarListarModule) },
    { path: 'editar', data: { breadcrumb : 'Editar' }, loadChildren: () => import('./caixa-gerenciar-editar/caixa-gerenciar-editar.module').then(m => m.CaixaGerenciarEditarModule) },
    { path: 'detalhar', data: { breadcrumb : 'Detalhar' }, loadChildren: () => import('./caixa-gerenciar-detalhar/caixa-gerenciar-detalhar.module').then(m => m.CaixaGerenciarDetalharModule) },
  ])],
  exports: [RouterModule]
})
export class CaixaGerenciarRoutingModule { }
